import { NetworkStatus, useQuery } from "@apollo/client";

import { VENDOR_KEY } from "constants/vendor";

import { GET_STACK_VENDOR_RESOURCES } from "./gql";
import { makeVendorQueryVariables } from "./helpers";
import { StackVendorResources } from "./types";

type UseGetVendorResourcesProps = {
  vendorSpecific?: VENDOR_KEY;
};

const useGetVendorResources = ({ vendorSpecific }: UseGetVendorResourcesProps) => {
  const { data, loading, refetch, networkStatus } = useQuery<StackVendorResources>(
    GET_STACK_VENDOR_RESOURCES,
    {
      variables: makeVendorQueryVariables(vendorSpecific),
    }
  );

  return {
    terraformVersions: data?.terraformVersions,
    openTofuVersions: data?.openTofuVersions,
    kubectlVersions: data?.kubectlVersions,
    terragruntVersions: data?.terragruntVersions,
    isDataLoading: loading && networkStatus !== NetworkStatus.refetch,
    isRefetching: loading && networkStatus === NetworkStatus.refetch,
    refetch,
  };
};

export default useGetVendorResources;
